import React from 'react';
import PropTypes from 'prop-types';

/***styles ***/
import './style.css';

export const HorizontalArrows = (props) => {

  /*** calculate Arrow Width  if passed maxArrowWidth and minArrowWidth else arrowWidth will default 10px ***/
  const calculatedArrowWidth = (props.maxArrowWidth && props.minArrowWidth) ?
    `calc( (100vw - 375px)/(1920 - 375) * (${props.maxArrowWidth} - ${props.minArrowWidth}) + ${props.minArrowWidth}px)` :
    `${props.arrowWidth}`,

    /*** calculate ArrowHeight if passed maxArrowHeight and minArrowHeight else arrowHeight will 5px ***/
    calculatedArrowHeight = (props.maxArrowHeight && props.minArrowHeight) ?
      `calc( (100vw - 375px)/(1920 - 375) * (${props.maxArrowHeight} - ${props.minArrowHeight}) + ${props.minArrowHeight}px)` :
      `${props.arrowHeight}`,
    margin = (props.top || props.bottom) ?
      {bottom: props.bottom} :
      {top: 0, bottom: 0, right: 0, left: 0, margin: "auto"},

    styleHorizontalArrows = {
      height: calculatedArrowHeight,
      gridTemplateColumns: `${calculatedArrowWidth} auto ${calculatedArrowWidth}`,
      ...margin
    },
    styleLeftArrow = {
      borderTop: `${calculatedArrowHeight} solid transparent`,
      borderBottom: `${calculatedArrowHeight} solid transparent`,
      borderRight: `${calculatedArrowWidth} solid ${props.borderColor}`
    },
    styleRightArrow = {
      borderTop: `${calculatedArrowHeight} solid transparent`,
      borderBottom: `${calculatedArrowHeight} solid transparent`,
      borderLeft: `${calculatedArrowWidth} solid ${props.borderColor}`
    },
    styleLineArrow = {
      border: `1px solid ${props.borderColor}`
    },
    styleInputHorizontalArrow = {
      /*
      bottom: props.bottom,
      top: props.top
      */
      color: `${props.borderColor}`
    };

  return (
    <div className="horizontal-arrows" style={styleHorizontalArrows}>
      <div className="wrapper-left-arrow">
        <span className="left-arrow" style={styleLeftArrow}/>
      </div>
      <div className="wrapper-line-arrow">
        <span className="line-arrow" style={styleLineArrow}/>
        <p className="input-line-arrow" style={styleInputHorizontalArrow}>{props.value}</p>
        {/*
                {props.isInput ?
                    <input
                        type="number"
                        data-input-name = {props.dataInputName}
                        className={"input-line-arrow"}
                        onChange={props.changeInputValue}
                        value = {props.value}
                        min = {0}
                        step = {props.step || 20}
                        readOnly={props.value && !props.changeInputValue}
                        disabled={props.value && !props.changeInputValue}
                    /> :
                    null }
                    */}
      </div>
      <div className="wrapper-right-arrow">
        <span className="right-arrow" style={styleRightArrow}/>
      </div>
    </div>
  )
};

HorizontalArrows.defaultProps = {
  arrowHeight: "5px",
  arrowWidth: "10px",
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  margin: "auto",
  borderColor: "black"
};

HorizontalArrows.propTypes = {
  arrowHeight: PropTypes.string,
  borderColor: PropTypes.string,
  arrowWidth: PropTypes.string,
  top: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  bottom: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  isInput: PropTypes.bool,
  dataInputName: PropTypes.string,
  changeInputValue: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
};



// WEBPACK FOOTER //
// ./src/components/buildcomponent/HorizontalArrows/HorizontalArrows.js